var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4688 13.5C24.4688 19.5579 19.5579 24.4688 13.5 24.4688M24.4688 13.5C24.4688 7.44213 19.5579 2.53125 13.5 2.53125M24.4688 13.5H2.53125M13.5 24.4688C7.44213 24.4688 2.53125 19.5579 2.53125 13.5M13.5 24.4688C15.83 24.4688 17.7188 19.5579 17.7188 13.5C17.7188 7.44213 15.83 2.53125 13.5 2.53125M13.5 24.4688C11.17 24.4688 9.28125 19.5579 9.28125 13.5C9.28125 7.44213 11.17 2.53125 13.5 2.53125M2.53125 13.5C2.53125 7.44213 7.44213 2.53125 13.5 2.53125",
    stroke: "#3373EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicSelected);
export default __webpack_public_path__ + "static/media/public-selected.70e3984b32d6c9136eeb6eff94ebeb99.svg";
export { ForwardRef as ReactComponent };